module.exports = __webpack_public_path__ + "static/media/SF_bm_sentrert_logo_vestland_pos.dd7dea53.svg";